import * as React from "react";
import {
  Badge,
  Box,
  BottomNavigationAction,
  BottomNavigation,
  LinearProgress,
  useTheme,
  styled,
} from "@mui/material";
// import AddRoundedIcon from "@mui/icons-material/AddRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ExploreRoundedIcon from "@mui/icons-material/ExploreRounded";
import ExploreOutlinedIcon from "@mui/icons-material/ExploreOutlined";
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router";
import { useEffect } from "react";
import useSWR from "swr";

import {
  getSettingState,
  setAlertDialog,
  setAlertDialogData,
  setLoadNavigation,
} from "../../../redux/features/settingSlice";
import MinimizePlayer from "../MinimizePlayer";
import { getPlayerState } from "../../../redux/features/playerSlice";
import { fetcherGetToken } from "../../../services/fetcher";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: 1,
    top: 1,
    border: "1px solid",
    borderColor: "primary.main",
    color: "white",
    paddingTop: "3px",
  },
}));

const FooterNav = () => {
  const [value, setValue] = React.useState("home");
  const { userData, loadNavigation, customModal } =
    useSelector(getSettingState);
  const { minimizePlayer } = useSelector(getPlayerState);
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  let urlParams = location.pathname.split("/");
  const dispatch = useDispatch();
  const tokenStorage = JSON.parse(localStorage.getItem("token")) || null;

  const { data: notificationCount } = useSWR(
    () => {
      if (!userData) {
        return null;
      }
      return [
        `${process.env.REACT_APP_API}/notifications/unread-count/`,
        tokenStorage,
      ];
    },
    fetcherGetToken,
    { refreshInterval: 6000 }
  );

  // disable load process on footer
  useEffect(() => {
    dispatch(setLoadNavigation(false));
  }, [location, dispatch]);

  const HoverFooterBtn = () => {
    return (
      <Box
        className='hoverBtn'
        sx={{
          position: "absolute",
          width: 64,
          height: 32,
          display: "block",
          padding: "8px",
          background: theme.palette.whiteDisabled2.main,
          borderRadius: "24px",
        }}
      ></Box>
    );
  };

  const handleChange = (event, newValue) => {
    if (newValue === "home" && urlParams[1] !== "") {
      navigate("/");
    }
    if (newValue === "explore" && urlParams[1] !== "explore") {
      navigate("/explore");
    }
    if (newValue === "notification" && urlParams[1] !== "notification") {
      if (userData) {
        navigate("/notification");
      } else {
        dispatch(setAlertDialog(true));
        dispatch(
          setAlertDialogData({
            title: "You are not logged in!",
            dis: "You must log in to your account to see notification.",
            btn1: "Cancel",
            btn2: "Login",
            btn2Onclick: () => navigate("/login"),
          })
        );
      }
    }
    if (newValue === "profile") {
      navigate("/profile");
    }

    setValue(newValue);
  };

  return (
    <Box>
      {urlParams[5] !== "topics" &&
        urlParams[1] !== "login" &&
        urlParams[1] !== "comment" &&
        urlParams[3] !== "comment" &&
        urlParams[1] !== "underconstruction" &&
        urlParams[2] !== "editprofile" &&
        urlParams[5] !== "addpost" && (
          <>
            {loadNavigation && !customModal && (
              <Box
                sx={{
                  width: "100%",
                  position: "absolute",
                  bottom: "60px",
                  zIndex: 4,
                }}
              >
                <LinearProgress color='primary' />
              </Box>
            )}
            <motion.div
              layout
              style={{
                position: "fixed",
                bottom: minimizePlayer ? "64px" : "-104px",
                display: "flex",
                justifyContent: "center",
                right: 0,
                left: 0,
                zIndex: 3,
              }}
            >
              <MinimizePlayer />
            </motion.div>
            <Box
              sx={{
                position: "fixed",
                bottom: "0",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                zIndex: 3,
                right: 0,
                left: 0,
              }}
            >
              {/* <Fab
          size={smWidth ? "large" : "small"}
          color='primary'
          aria-label='add'
          sx={{
            width: smWidth ? "64px" : "48px",
            height: smWidth ? "64px" : "48px",
            position: "absolute",
            top: "-32px",
            border: "2px solid",
            borderColor: "black.main",
            boxShadow: `0px 4px 0px ${theme.palette.black.main}`,
            borderRadius: "32px",
            "&.MuiButtonBase-root:hover": {
              border: "none",
              backgroundColor: "primary.main",
            },
            "&.MuiButtonBase-root:active": {
              backgroundColor: "black.main",
              boxShadow: "none",
              color: "white.main",
              border: "none",
            },
          }}
        >
          <AddRoundedIcon sx={{ fontSize: "38px" }} />
        </Fab> */}

              <BottomNavigation
                sx={{
                  width: "100%",
                  height: "64px",
                  boxShadow: `inset 0px 2px 0px ${theme.palette.black.main}`,
                  // "& .MuiBottomNavigationAction-root.Mui-selected .hoverBtn": {
                  //   display: "block",
                  // },
                  // "& .MuiBottomNavigationAction-root": {
                  //   color: "white.main",
                  // },
                  // "& .MuiBottomNavigationAction-root.Mui-selected": {
                  //   color: "black.main",
                  // },
                }}
                value={value}
                onChange={handleChange}
              >
                <BottomNavigationAction
                  sx={{ minWidth: 50 }}
                  value='home'
                  icon={
                    <>
                      {urlParams[1] !== "explore" &&
                        urlParams[1] !== "notification" &&
                        urlParams[1] !== "profile" && <HoverFooterBtn />}
                      <Box sx={{ paddingTop: "8px", zIndex: "1" }}>
                        {urlParams[1] !== "explore" &&
                        urlParams[1] !== "notification" &&
                        urlParams[1] !== "profile" ? (
                          <HomeRoundedIcon sx={{ color: "#212121" }} />
                        ) : (
                          <HomeOutlinedIcon sx={{ color: "black.main" }} />
                        )}
                      </Box>
                    </>
                  }
                />

                <BottomNavigationAction
                  sx={{ minWidth: 50 }}
                  value='explore'
                  icon={
                    <>
                      {urlParams[1] === "profile" && urlParams[2] ? (
                        <>
                          <HoverFooterBtn />
                          <Box sx={{ paddingTop: "8px", zIndex: "1" }}>
                            <ExploreRoundedIcon sx={{ color: "#212121" }} />
                          </Box>
                        </>
                      ) : (
                        <>
                          {urlParams[1] === "explore" && <HoverFooterBtn />}
                          <Box sx={{ paddingTop: "9px", zIndex: "1" }}>
                            {urlParams[1] === "explore" ? (
                              <ExploreRoundedIcon sx={{ color: "#212121" }} />
                            ) : (
                              <ExploreOutlinedIcon
                                sx={{ color: "black.main" }}
                              />
                            )}
                          </Box>
                        </>
                      )}
                    </>
                  }
                />
                {/* <BottomNavigationAction
            sx={{ minWidth: 50 }}
            value='add'
            icon={
              <Box
                sx={{
                  backgroundColor: "primary.main",
                  width: "32px",
                  height: "32px",
                  minWidth: "32px",
                  minHeight: "32px",
                  border: "2px solid",
                  borderColor: "black.main",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  boxShadow: `0px 2px 0px ${theme.palette.black.main}`,
                  borderRadius: "8px",
                  padding: "4px",
                  "&.MuiBox-root:hover": {
                    border: "none",
                    backgroundColor: "primary.main",
                  },
                  "&.MuiBox-root:active": {
                    backgroundColor: "black.main",
                    boxShadow: "none",
                    color: "white.main",
                    border: "none",
                  },
                }}
              >
                <AddRoundedIcon sx={{ fontSize: "24px" }} />
              </Box>
            }
          /> */}

                <BottomNavigationAction
                  sx={{ minWidth: 50 }}
                  value='notification'
                  icon={
                    <>
                      {urlParams[1] === "notification" && <HoverFooterBtn />}
                      <Box sx={{ paddingTop: "1px", zIndex: "1" }}>
                        <StyledBadge
                          badgeContent={notificationCount?.unread_count}
                          color='danger'
                          variant='standard'
                        >
                          {urlParams[1] === "notification" ? (
                            <NotificationsRoundedIcon
                              sx={{ color: "#212121" }}
                            />
                          ) : (
                            <NotificationsOutlinedIcon
                              sx={{ color: "black.main" }}
                            />
                          )}
                        </StyledBadge>
                      </Box>
                    </>
                  }
                />

                <BottomNavigationAction
                  sx={{ minWidth: 50 }}
                  value='profile'
                  icon={
                    <>
                      {!urlParams[2] && urlParams[1] === "profile" && (
                        <HoverFooterBtn />
                      )}
                      <Box sx={{ paddingTop: "7px", zIndex: "1" }}>
                        {!urlParams[2] && urlParams[1] === "profile" ? (
                          <AccountCircleRoundedIcon sx={{ color: "#212121" }} />
                        ) : (
                          <AccountCircleOutlinedIcon
                            sx={{ color: "black.main" }}
                          />
                        )}
                      </Box>
                    </>
                  }
                />
              </BottomNavigation>
            </Box>
            {loadNavigation && customModal && (
              <Box
                sx={{
                  width: "100%",
                  position: "absolute",
                  bottom: "0px",
                  zIndex: 10,
                }}
              >
                <LinearProgress color='primary' />
              </Box>
            )}
          </>
        )}
    </Box>
  );
};
export default FooterNav;
